import React from "react";
import { SkeletonBlock } from "./SkeletonUI";

const ServicesSkeletonLoader = () => (
  <section className="container" style={{ padding: "72px 0 80px" }}>
    {/* Section label + heading */}
    <SkeletonBlock width={100} height={10} style={{ marginBottom: 12 }} />
    <SkeletonBlock width={200} height={34} style={{ marginBottom: 48 }} />

    {/* Grid of cards */}
    <div style={{
      display: "grid",
      gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))",
      gap: 24,
    }}>
      {[0, 1, 2, 3, 4, 5].map(i => (
        <div key={i} style={{
          borderRadius: 14,
          overflow: "hidden",
          border: "1px solid #f0f0f0",
          background: "#fafafa",
        }}>
          <SkeletonBlock height={220} radius={0} />
          <div style={{ padding: "22px 24px 28px" }}>
            <SkeletonBlock height={20} style={{ marginBottom: 10 }} />
            <SkeletonBlock width="70%" height={20} style={{ marginBottom: 16 }} />
            <SkeletonBlock height={13} style={{ marginBottom: 6 }} />
            <SkeletonBlock width="80%" height={13} style={{ marginBottom: 20 }} />
            <SkeletonBlock width={90} height={13} />
          </div>
        </div>
      ))}
    </div>
  </section>
);

export default ServicesSkeletonLoader;
